<template>
  <el-form
    size="small"
    :label-position="$i18n.locale !== 'zh' ? 'top' : 'right'"
    :label-width="$i18n.locale !== 'zh' ? 'auto' : '120px'"
  >
    <el-row>
      <!--      快递应收-->
      <template v-if="type === 1">
        <el-col :span="6">
          <!--业务单号-->
          <el-form-item :label="$t('receivablePayable.TicketNumber') + '：'">
            {{ formData.waybillNumber }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--客户单号-->
          <el-form-item :label="$t('receivablePayable.CustomerTrackingNumber') + '：'">
            {{ formData.customerNumber }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--站点-->
          <el-form-item :label="$t('basicData.Outlets') + '：'">
            {{ formData.siteName }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--客户-->
          <el-form-item :label="$t('receivablePayable.customer') + '：'">
            {{ formData.customerAlias }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--包裹类型-->
          <el-form-item :label="$t('placeOrder.packageType') + '：'">
            <span v-if="formData.orderPackageType === 1">{{ $t('placeOrder.zhifa') }}</span> <!--直单-->
            <span v-if="formData.orderPackageType === 2">{{ $t('placeOrder.CoPacking') }}</span> <!--核弹-->
            <span v-if="formData.orderPackageType === 3">{{ $t('basicData.other') }}</span> <!--其他-->
            <span v-if="formData.orderPackageType === 4">{{ $t('placeOrder.big01') }}</span> <!--大件-->
            <span v-if="formData.orderPackageType === 5">{{ $t('basicData.OnePieceMultipleOrders') }}</span> <!--一件多单-->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--计费重量-->
          <el-form-item :label="$t('receivablePayable.BillableWeight') + '：'">
            {{ formData.chargeWeight }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--收件人邮编-->
          <el-form-item :label="$t('collectionCenter.Recipientzc') + '：'">
            {{ formData.receiveZipcode }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--发件人邮编-->
          <el-form-item :label="$t('collectionCenter.senderZipCode') + '：'">
            {{ formData.senderZipcode }}
          </el-form-item>
        </el-col>
      </template>
      <!--      整车-->
      <template v-else>
        <el-col :span="6">
          <!--订单号-->
          <el-form-item :label="$t('basicData.OrderNumber') + '：'">
            {{ formData.orderNumber }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--下单客户-->
          <el-form-item :label="$t('basicData.OrderingCustomer') + '：'">
            {{ formData.orderCustomerAlias }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--装卸类型-->
          <el-form-item :label="$t('basicData.UnloadingType') + '：'">
            {{ formData.loadingTypeAlias }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--付款方式-->
          <el-form-item :label="$t('basicData.PaymentMethod') + '：'">
            {{ formData.paymentMethodAlias }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--里程-->
          <el-form-item :label="$t('basicData.Mileage') + '：'">
            {{ formData.totalMileage }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--车型-->
          <el-form-item :label="$t('vehicle.modelLabel') + '：'">
            {{ formData.vehicleTypeAlias }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--发票金额-->
          <el-form-item :label="$t('GlobalSetObj.TheInvoiceAmount') + '：'">
            {{ formData.totalInvoiceMoney }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--体积-->
          <el-form-item :label="$t('basicData.Volume') + '：'">
            {{ formData.totalVolume }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--发件人城市-->
          <el-form-item :label="$t('collectionCenter.SenderCity') + '：'">
            {{ formData.senderCity }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--收件人城市-->
          <el-form-item :label="$t('collectionCenter.receiveCity') + '：'">
            {{ formData.receiverCity }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--业务时间-->
          <el-form-item :label="$t('basicData.BusinessTime') + '：'">
            {{ formData.businessTime }}
          </el-form-item>
        </el-col>
      </template>
      <el-col :span="24">
        <!--备注-->
        <el-form-item :label="$t('receivablePayable.remark') + '：'">
          {{ formData.remark }}
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 1
    },
    addBatchFee: {
      type: Object,
      default: () => ({
        waybillNumber: '',
        customerNumber: '',
        siteName: '',
        customerAlias: '',
        orderPackageType: '',
        chargeWeight: '',
        receiveZipcode: '',
        senderZipcode: '',
        orderNumber: '',
        orderCustomerAlias: '',
        loadingTypeAlias: '',
        paymentMethodAlias: '',
        totalMileage: '',
        vehicleTypeAlias: '',
        totalInvoiceMoney: '',
        totalVolume: '',
        senderCity: '',
        receiveCity: '',
        businessTime: '',
        remark: ''
      })
    }
  },
  data() {
    return {
      formData: {}
    };
  },
  watch: {
    addBatchFee: {
      handler(val) {
        this.formData = val;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
</style>

